import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import { ISubjectPage } from "../model/interface/subject";
import { ISupersheetFilter } from "../model/interface/supersheet";

export const getSupersheet = (model: ISupersheetFilter) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUPERSHEET_ALL, {
    params: {
      name: model.name,
      supersheetId: model.supersheetId,
      gradeId: model.gradeId,
      contentAreaId: model.contentAreaId,
      gradeLevel: model.gradeLevel,
      pageSize: model.pageSize,
      pageNumber: model.pageNumber,
      orderbyColumn: model.orderbyColumn,
      sortDir: model.sortDir,
      isActive: model.isActive,
      isApproved: model.isApproved,
      SubjectId: model.subjectId,
      SubjectTypeId: model.subjectTypeId,
      isAlert: model.isAlert,
    },
  });
};

export const getSubjectAllByContent = (
  userId: any,
  gradeId: any,
  contentId: any
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUPERSHEET_Subjects, {
    params: {
      userId: userId,
      gradeId: gradeId,
      contentAreaId: contentId,
    },
  });
};

export const getSubjectDropdown = (
  OrderByColumn = "name",
  SortDir = "asc",
  PageSize = 100,
  PageNumber = 1
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      OrderByColumn: OrderByColumn,
      SortDir: SortDir,
      PageSize: PageSize,
      PageNumber: PageNumber,
    },
  });
};

export const getGradeAll = (PageSize = 10, PageNumber = 1) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_GRADE_ALL, {
    params: {
      PageSize: PageSize,
      PageNumber: PageNumber,
      isActive: true,
    },
  });
};

export const getSubjectAll = (PageSize = 10, PageNumber = 1) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      PageSize: 999999,
      PageNumber: PageNumber,
      ColumnName: "Name",
      SortDir: "asc",
      isActive: true,
      isApproved: true,
      isStandardFilter: true,
    },
  });
};

export const getStateAll = (PageSize: number, PageNumber: number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_STATE, {
    params: {
      PageSize: PageSize,
      PageNumber: PageNumber,
    },
  });
};

export const getSupersheetAPI = (supersheetId) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_SUPERSHEET_GET}/${supersheetId}`,
    {}
  );
};

export const getSupersheetSubjectsByIdAPI = (supersheetId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SUPERSHEET_SUBJECT_GETBYID,
    {
      params: {
        supersheetId: supersheetId,
      },
    }
  );
};

export const getScoringAlgorithm = () => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_SUBJECT_SCORINGALGORITHM}`,
    {}
  );
};

export const postSupersheetAPI = (postSupersheetData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SUPERSHEET_ADD,
    postSupersheetData,
    {}
  );
};
export const updateSupersheetAPI = (updateSupersheetData) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_SUPERSHEET_UPDATE,
    updateSupersheetData,
    {}
  );
};

export const postSubjectAPI = (postSubjectData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SUBJECT,
    postSubjectData,
    {}
  );
};
export const deleteSubjectAPI = (subjectId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_SUBJECT, {
    params: {
      id: subjectId,
    },
  });
};
export const updateSubjectAPI = (updateSubjectData) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_SUBJECT,
    updateSubjectData,
    {}
  );
};

export const getSubjectByGrade = (PageSize = 10, PageNumber = 1, GradeId) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      OrderByColumn: "Name",
      SortDir: "asc",
      PageSize: PageSize,
      PageNumber: PageNumber,
      GradeId: GradeId,
      IsStandardFilter: true,
      IsActive: true,
      isApproved: true,
    },
  });
};

export const getSubjectByState = (
  PageSize = 10,
  PageNumber = 1,
  stateId,
  isActive,
  isApproved,
  gradeLevelId?
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      OrderByColumn: "Name",
      SortDir: "asc",
      PageSize: PageSize,
      PageNumber: PageNumber,
      StateId: stateId,
      isActive: isActive,
      isApproved: isApproved,
      gradeLevelId: gradeLevelId,
      isStandardFilter: true,
    },
  });
};

export const getSubjectByStateAndGrade = (
  PageSize = 10,
  PageNumber = 1,
  stateId,
  gradeId,
  subjectTypeId
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      OrderByColumn: "Name",
      SortDir: "asc",
      PageSize: PageSize,
      PageNumber: PageNumber,
      StateId: stateId,
      GradeId: gradeId,
      isActive: true,
      isApproved: true,
      SubjectTypeId: subjectTypeId,
    },
  });
};

export const getSubjectTypes = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_TYPES, {});
};

export const createSubjectClone = (subjectId: number) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_SUBJECT_CLONE}/${subjectId}`
  );
};

export const previewSuperSheet = (path: string) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUPERSHEET_PREVIEW, {
    params: {
      supersheetFile: path,
    },
  });
};

export const downloadaAnswerKeySupersheet = (
  supersheetId: any,
  userId: any
) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SUPERSHEET_DOWNLOADANSWERKEY,
    {
      responseType: "blob",
      params: {
        supersheetId: supersheetId,
        userId: userId,
      },
    }
  );
};

export const shareSupersheet = (supersheet: any) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SUPERSHEET_Create,
    supersheet,
    {}
  );
};

export const validateSupersheet = (supersheet: any) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SUPERSHEET_Validate,
    supersheet,
    {}
  );
};
